/**
 * @generated SignedSource<<331c0d3e6143424c59dcf76bb34862c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TemplateSelectorDeleteTemplateMutation$variables = {
  templateId: string;
};
export type TemplateSelectorDeleteTemplateMutation$data = {
  readonly todoWorkspaceTemplate: {
    readonly deleteTemplate: {
      readonly id: string;
    };
  };
};
export type TemplateSelectorDeleteTemplateMutation = {
  response: TemplateSelectorDeleteTemplateMutation$data;
  variables: TemplateSelectorDeleteTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "templateId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TemplateSelectorDeleteTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceTemplateMutation",
        "kind": "LinkedField",
        "name": "todoWorkspaceTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspaceTemplate",
            "kind": "LinkedField",
            "name": "deleteTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TemplateSelectorDeleteTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceTemplateMutation",
        "kind": "LinkedField",
        "name": "todoWorkspaceTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspaceTemplate",
            "kind": "LinkedField",
            "name": "deleteTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a50300e6a9d2f64276bce58c15a7cdf",
    "id": null,
    "metadata": {},
    "name": "TemplateSelectorDeleteTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation TemplateSelectorDeleteTemplateMutation(\n  $templateId: ID!\n) {\n  todoWorkspaceTemplate(id: $templateId) {\n    deleteTemplate {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "129e7b23285adbae09ec922755026c20";

export default node;
